module.exports = require('./lib/dom-scroll-into-view');



//////////////////
// WEBPACK FOOTER
// ./~/dom-scroll-into-view/index.js
// module id = 309
// module chunks = 0